module.exports = __webpack_public_path__ + "static/media/newsletter.091a848d.svg";